import { ref, reactive, computed, onMounted, watch, isRef } from '@vue/composition-api'
import appearancesApi from '@/services/api/appearances'
import { FRAME_CONFIG } from './constants'

export function defaultForm(config) {
  const form = {
    schema_color: '#aa2d41',
    sponsor_link: ''
  }
  if (config.hasLogoLinks) {
    for (let i = 1; i <= config.logoCount; i += 1) {
      form[`sponsor_logo_${i}_link`] = ''
    }
  }
  return form
}

export function defaultPreviews(config) {
  const previews = {}
  config.fileKeys.forEach((key) => {
    previews[key] = null
  })
  return previews
}

export function applyResponse(form, previews, data, config) {
  form.schema_color = data.schema_color != null ? data.schema_color : '#aa2d41'
  form.sponsor_link = data.sponsor_link != null ? data.sponsor_link : ''

  if (config.hasLogoLinks) {
    for (let i = 1; i <= config.logoCount; i += 1) {
      const linkKey = `sponsor_logo_${i}_link`
      form[linkKey] = data[linkKey] != null ? data[linkKey] : ''
    }
  }

  config.fileKeys.forEach((key) => {
    previews[key] = data[key] != null ? data[key] : null
  })
}

export default function useAppearance(frameArg) {
  const frameRef = isRef(frameArg) ? frameArg : ref(frameArg)
  const config = computed(() => FRAME_CONFIG[frameRef.value])

  const loading = ref(false)
  const form = reactive(defaultForm(config.value))
  const previews = reactive(defaultPreviews(config.value))

  async function fetch() {
    loading.value = true
    try {
      const res = await appearancesApi.get(frameRef.value)
      applyResponse(form, previews, res.data.data, config.value)
    } finally {
      loading.value = false
    }
  }

  watch(frameRef, () => {
    Object.assign(form, defaultForm(config.value))
    Object.assign(previews, defaultPreviews(config.value))
    fetch()
  })

  onMounted(fetch)

  return { loading, form, previews, config, fetch }
}



// WEBPACK FOOTER //
// ./src/composables/appearances/useAppearance.js